import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';


import { ApiEmplifiSearch, ApiHudsonNameContent, ApiHudsonSearch } from './api-hudson.models';


@Injectable()
export class ApiHudsonService {

  constructor(
    private readonly http: HttpClient
  ) { }

  public search(
    galleryId: string,
    limit: number,
    sort: string,
    country?: string,
    lang?: string
  ): Observable<ApiHudsonSearch> {
    const url = this.requestUrl(galleryId, limit, sort, country, lang);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    const requestOptions = { headers };
    return this.http.get<ApiHudsonSearch>(url, requestOptions).pipe(
      catchError((error) => (error.httpStatus === 404 ? of({}) : of(error)))
    );
  }

  public searchEmplifi(
    albumId: string,
    apiKey: string,
    limit: number,
    sort: string,
    regionId?: string
  ): Observable<ApiEmplifiSearch> {
    const url = this.requestEmplifiUrl(albumId, apiKey, limit, sort, regionId);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.get<ApiEmplifiSearch>(url, { headers }).pipe(
      catchError((error) => (error.httpStatus === 404 ? of({}) : of(error)))
    );
  }

  public searchMedia(mediaId: string): Observable<ApiHudsonNameContent> {
    const url = this.requestMediaUrl(mediaId);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    const requestOptions = { headers };
    return this.http.get<ApiHudsonNameContent>(url, requestOptions).pipe(
      catchError((error) => (error.httpStatus === 404 ? of({}) : of(error)))
    );
  }

  /**
   * Request to the /galleries endpoint of the API https://library-backend.dashhudson.com
   * @param galleryId Gallery Id
   * @param limit Number of items to be returned
   * @param sort Order of the elements
   * @param country Country code
   * @param lang Language code
   * @returns Observable with the data returned by the api /galleries
   */
  private requestUrl(galleryId: string, limit: number, sort: string, country?: string, lang?: string): string {
    return 'https://library-backend.dashhudson.com'
      + `/public/brands/1453/galleries/${galleryId}/media?limit=${limit}&offset=0&sort=${sort}&include_product_overrides=${country}_${lang}`;
  }

  /**
   * Request to the /albums/{albumId}/photos endpoint of the Emplifi API https://distillery.pixlee.co
   * @param albumId Album Id
   * @param apiKey API Key
   * @param limit Number of items to be returned
   * @param sort Order of the elements
   * @param regionId Region Id
   * @returns URL for the Emplifi API request
   */
  private requestEmplifiUrl(albumId: string, apiKey: string, limit: number, sort: string, regionId?: string): string {
    const baseUrl = `https://distillery.pixlee.co/api/v2/albums/${albumId}/photos?api_key=${apiKey}&per_page=${limit}&sort=${sort}`;
    return regionId ? `${baseUrl}&region_id=${regionId}` : baseUrl;
  }

  /**
   * Request to the /media endpoint of the API https://library-backend.dashhudson.com
   * @param mediaId Media Id
   * @returns Observable with the data returned by the api /media/v2
   */
  private requestMediaUrl(mediaId: string): string {
    return `https://library-backend.dashhudson.com/public/brands/1453/media/v2/${mediaId}`;
  }

}
